// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import { LocalKeyData } from "../../../../engines/libs/LocalKeyData";
import { GAME_MODE } from "../../../../engines/managers/gameContent/gameMode_json";
import superService from "../../../../engines/services/superService";
import ModelDialogLayer from "../../../gameCommon/basic/ModelDialogLayer";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

const g_Key = 'SaveRecordDataDot';
@ccclass
export default class GameTestLayer extends BasePopUpLayer {

    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.node.zIndex = cc.macro.MAX_ZINDEX-1;
    }

    onClickSave() {
		ModelDialogLayer.show('是否存档'
            , null
            , () => {
                let keyList = LocalKeyData.getData();
                let dataList = {};
                let localStorage = cc.sys.localStorage;
                for (let i = 0; i < localStorage.length; i++) {
                    let key = localStorage.key(i);
                    if (key == g_Key) {
                        continue;
                    }
                    let data = localStorage.getItem(key);
                    dataList[key] = data;
                }
                for (let key in keyList) {
                    if (dataList[key]) {
                        continue;
                    }
                    let data = localStorage.getItem(key);
                    // if (!data) {
                    // 	data = localData.instance.getLocalDataByKey(key, {});
                    // }
                    dataList[key] = data;
                }
                // localStorage.clear();
                localStorage.setItem(g_Key, JSON.stringify(dataList));
            }
			, null
            , null
            , false
            , cc.macro.MAX_ZINDEX
		);
	}

	onClickRead() {

		// cc.log('--- cc.assetManager.assets', cc.assetManager.assets);
		// return;
		let localStorage = cc.sys.localStorage;
		let dataList = localStorage.getItem(g_Key);
		if (!dataList || dataList == '') {
            O1HD.getModules().uiControlModule.showMessageBox("未找到存档数据");
			return;
		}
		ModelDialogLayer.show('读取存档，将覆盖当前数据。'
            , null
            , () => {
                let jsonList = JSON.parse(dataList);
                jsonList[g_Key] = dataList;
                localStorage.clear();
                for (let i in jsonList) {
                    let o = jsonList[i];
                    localStorage.setItem(i, o);
                }
                LocalKeyData.resetData();
			    LocalKeyData.loadLocalData();

                let services = O1HD.getServices();
                for (let i in services) {
                    (services[i] as superService).setLoadedState(false);
                }

                O1HD.loadScene('loading');
                // O1HD.loadScene('start');
                // NormalGameManager._instance.resetManager();
                // O1HD.getManagers().gameMgr.selectMode( GAME_MODE.NORMAL ).then();
            }
			, null
            , null
            , false
            , cc.macro.MAX_ZINDEX
		);
	}

    // update (dt) {}
}
